import { Check } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

export function WhatsIncluded() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].included;

  return (
    <section className="bg-ivory py-20 sm:py-28" data-testid="whats-included">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} />

        <div className="mt-14 grid gap-3 sm:grid-cols-2">
          {t.items.map((item, i) => (
            <Reveal key={item} delay={(i % 2) * 70}>
              <div className="flex items-center gap-3 rounded-2xl border border-navy/8 bg-white px-5 py-4 transition-colors duration-300 hover:border-gold/40">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 ring-1 ring-emerald-100">
                  <Check className="h-4 w-4" strokeWidth={3} />
                </span>
                <span className="text-sm font-medium text-navy sm:text-base">{item}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
